import { render, staticRenderFns } from "./KitImageGroup.vue?vue&type=template&id=5432e30c&scoped=true&"
import script from "./KitImageGroup.vue?vue&type=script&lang=js&"
export * from "./KitImageGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5432e30c",
  null
  
)

export default component.exports